<template>
    <div class="loader-container">
        <div class="loader">
            <Logo/>
            <div class="progress-bar"/>
        </div>
    </div>
</template>

<script>
import Logo from './Logo';

export default {
    name: 'Loader',

    components: {
        Logo
    }
};
</script>

<style lang="less">
    @loader-width: 400px;

    .loader img {
        display: block;
        height: 75px;
        margin: 0 auto;
    }
</style>

<style lang="less" scoped>

    @import "../styles/colors.less";

    @loader-width: 400px;

    .loader-container {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        display: flex;
        align-items: center;
        z-index: 1000000;
        background-color: @color-white;
    }

    .loader {
        width: @loader-width;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .progress-bar {
        width: @loader-width;
        height: 8px;
        animation: progress-bar-stripes 1.5s linear infinite;
        background-image: linear-gradient(to right, #6786de 0%, #cc66de 50%, #6786de 100%);
        border-radius: 2px;
        margin: 20px auto 0;
    }

    @keyframes progress-bar-stripes {
        to {
            background-position: @loader-width 0;
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/Loader.vue